/**
 * 亮度/对比度（对比 Photoshop 补全第一档缺口 阶段 1；`brightnessContrast`
 * 这个 kind 之前只占了类型联合的位置，从来没被实现过，这次补上）。
 *
 * 用 Photoshop"旧版"算法（`legacy` 复选框那条路径）：对比度换成
 * `tan((contrast+100)/200 * π/2)` 斜率，围绕中灰 127.5 旋转；亮度是加法
 * 偏移。比新版的分段曲线算法简单可靠，contrast=100 时斜率趋于极大值，
 * `Math.min`/`Math.max` 的夹取让它自然退化成阈值二值化（跟真实 Photoshop
 * 拉满对比度时的效果一致），不需要额外特判。
 */
export interface BrightnessContrastParams {
  /** 亮度，−100–100。 */
  readonly brightness: number;
  /** 对比度，−100–100。 */
  readonly contrast: number;
}

export const DEFAULT_BRIGHTNESS_CONTRAST_PARAMS: BrightnessContrastParams = {
  brightness: 0,
  contrast: 0,
};

export function brightnessContrastLut(params: BrightnessContrastParams): Uint8Array {
  const contrast = Math.min(100, Math.max(-100, params.contrast));
  const brightness = Math.min(100, Math.max(-100, params.brightness));
  const factor = Math.tan(((contrast + 100) / 200) * (Math.PI / 2));
  const lut = new Uint8Array(256);
  for (let v = 0; v < 256; v++) {
    const out = (v - 127.5) * factor + 127.5 + brightness;
    lut[v] = Math.round(Math.min(255, Math.max(0, out)));
  }
  return lut;
}
